import Loader from '@/components/ui/loader'
import { cn } from '@/lib/utils'

export default function PendingComponent({ className }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('flex grow items-center justify-center', className)}>
      <Loader className="size-12" />
    </div>
  )
}
